import React from "react";
import "./QuickLinks.scss";
import druvstarLogoFinal_whitesmall from "../../../assets/icons/druvstarLogoFinal_whitesmall.svg";
import DTILogosmall from "../../../assets/icons/DTILogosmall.svg";
import govfulllogo from "../../../assets/icons/govfulllogo.svg";
import govfulllogosmall from "../../../assets/icons/govfulllogosmall.svg";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { MDR, DDV, RISK } from "../../../redux/constants/constants";
import MDRLogoSmall from "../../../assets/vizr_images/MDRLogoSmall.svg";
import SmallDruvstarLogo from "../../../assets/vizr_images/logo.svg";
import { dashboardRoute } from "../../common/Dashboard/utils";
import  { isDataGuardEnabled } from "../../common/Dashboard/utils";
import DataGuard_large from "../../../assets/vizr_images/DataGuard_large.svg";
import DataGuardshrink from "../../../assets/vizr_images/DataGuardshrink-cropped.svg";
import store from "../../../redux/store/store";
const DDV_img = () => isDataGuardEnabled() ? {
    src: DataGuardshrink,
    shrunkSrc: DataGuardshrink,
    alt: "DataGuard",
    className: "data-guard-logo",
} : {
    src: SmallDruvstarLogo,
    shrunkSrc: SmallDruvstarLogo,
    alt: "Datavision",
}

const QuickLinks = ({ currentPage, shrunk=false, noMargin=false }) => {
    const QUICK_LINKS = {
        DDV: {
            ...DDV_img(),
            name1: "DRUVSTAR",
            name2: isDataGuardEnabled() ? <span>DATA GUARD<sup className="trademark">®</sup></span> : <span>DATA VISION<sup className="trademark">®</sup></span>,
            onClick: () => {
                history.push(dashboardRoute());
                dispatch({
                    type: "TRACK_TRAVERSAL",
                    payload: "Dashboard",
                });
            }
        },
        MDR: {
            src: MDRLogoSmall,
            shrunkSrc: MDRLogoSmall,
            alt: "Threat Insights",
            name1: "DRUVSTAR",
            name2: <span className="threat-insights-txt">THREAT INSIGHTS<sup className="trademark">®</sup></span>,
            onClick: () => {
                history.push("/mdr/MDRdashboards");
                dispatch({
                    type: "TRACK_TRAVERSAL",
                    payload: "Threat Insights Dashboard",
                });
            }
        },
        RISK: {
            src: govfulllogosmall,
            shrunkSrc: govfulllogosmall,
            alt: "Governor",
            name1: "DRUVSTAR",
            name2: <span>GOVERNOR<sup className="trademark">®</sup></span>,
            onClick: () => {
                history.push("/gov/GOVdashboards");
            }
        }
    };
    const history = useHistory();
    const dispatch = useDispatch();
    const items = [];
    const featuresData = JSON.parse(localStorage.getItem("featuresInfo"));
    const permissions = store.getState().applicationData.permissions;
    const features =
        featuresData &&
        featuresData.features &&
        featuresData.features.map((data) => data.name);
    if (currentPage === RISK) {
        if (features && features.includes(DDV) && permissions?.includes("VIEW_DATA_VISION")) {
            items.push(QUICK_LINKS.DDV);
        }
        if (features && features.includes(MDR) && permissions?.includes("VIEW_THREAT_INSIGHTS")) {
            items.push(QUICK_LINKS.MDR);
        }
    } else if (currentPage === DDV) {
        if (features && features.includes(MDR) && permissions?.includes("VIEW_THREAT_INSIGHTS")) {
            items.push(QUICK_LINKS.MDR);
        }
        if (features && features.includes(RISK) && permissions?.includes("VIEW_RISK_GOVERNOR")) {
            items.push(QUICK_LINKS.RISK);
        }
    } else if (currentPage === MDR) {
        if (features && features.includes(DDV) && permissions?.includes("VIEW_DATA_VISION")) {
            items.push(QUICK_LINKS.DDV);
        }
        if (features && features.includes(RISK) && permissions?.includes("VIEW_RISK_GOVERNOR")) {
            items.push(QUICK_LINKS.RISK);
        }
    }
    return (
        items.length > 0 &&
        <div>
            {shrunk ? 
            <div className={(!noMargin && currentPage === DDV)?"quick-link-wrapper no-margin":"quick-link-wrapper"}>
                <div className="shrink-container">
                    {items[0] && <div className="item">
                        <img
                            src={items[0].shrunkSrc}
                            alt={items[0].alt}
                            onClick={items[0].onClick}
                            className={items[0].className? items[0].className : "" }
                        ></img>
                    </div>}
                    {items[1] && <>
                        <hr className="divider" />
                        <div className="item">
                            <img
                                src={items[1].shrunkSrc}
                                alt={items[1].alt}
                                onClick={items[1].onClick}
                                className={items[1].className? items[1].className : "" }
                            ></img>
                        </div>
                    </>}
                </div>
            </div>
             : <div className={(noMargin && currentPage === DDV)?"quick-link-wrapper no-margin":"quick-link-wrapper"}>
                <h4>Quick Links:</h4>
                <div className="quick-link-container">
                    {items[0] && <div className="item" onClick={items[0].onClick}>
                        <div className="product-icon">
                            <img
                                src={items[0].src}
                                alt={items[0].alt}
                                className={items[0].className? items[0].className : "" }
                            />
                        </div>
                        <div className="product-text">
                            <div className="product-name-1">{items[0].name1}</div>
                            <div className="product-name-2">{items[0].name2}</div>
                        </div>
                    </div>}
                    {items[1] && <>
                        <hr className="divider" />
                        <div className="item" onClick={items[1].onClick}>
                            <div className="product-icon">
                                <img
                                    src={items[1].src}
                                    alt={items[1].alt}
                                    className={items[1].className? items[1].className : "" }
                                />
                            </div>
                            <div className="product-text">
                                <div className="product-name-1">{items[1].name1}</div>
                                <div className="product-name-2">{items[1].name2}</div>
                            </div>
                        </div>
                    </>}
                </div>
            </div>}
        </div>
    );
};

export default QuickLinks;